export default "__VITE_ASSET__hky1JTvt__"